import React, { useEffect, useState } from "react";
import { useTranslation } from 'react-i18next';
import { Button } from "../../components/ui/button";
import ModalComponent from "./modal";
import { FaCreditCard } from "react-icons/fa";
import { scrollToTop } from "../../lib/utils";

const PasserCommande = () => {
  const { t } = useTranslation();
  const [isModalVisible, setIsModalVisible] = useState(false);

  useEffect(() => {
    scrollToTop()
  }, [])

  const handleOpenModal = () => {
    setIsModalVisible(true);
  };

  const handleCloseModal = () => {
    setIsModalVisible(false);
  };

  return (
    <div className="w-full h-full">
      <div className="h-[100px] flex items-center justify-center text-2xl">
        {t('order.passOrder')}
      </div>

      <div className="grid grid-cols-5 p-8 bg-gray-100 gap-3">
        <div className="col-span-3">
          <div className="bg-white p-6 shadow-lg rounded-lg h-[330px] ">
            <div className="flex flex-col items-start justify-start">
              <div className="text-2xl my-4">{t('order.paymentService')}</div>
              <div className="text-1xl my-4">{t('order.choosePaymentMethod')}</div>
              <div className="flex items-center justify-between mb-4 gap-4">
                <div className="flex flex-col items-center mr-4">
                  <FaCreditCard className="text-1xl text-gray-500" />
                  <span className="mt-1 text-1xl text-gray-400">
                    {t('order.creditCard')}
                  </span>
                </div>
                <div className="flex flex-row">
                  <label className="flex flex-col items-center space-x-4 mr-4">
                    <input type="radio" name="payment" value="OM" />
                    <span className="text-sm text-gray-400">OM</span>
                  </label>
                  <label className="flex flex-col items-center space-x-4 mr-4">
                    <input type="radio" name="payment" value="MOMO" />
                    <span className="text-sm text-gray-400">MOMO</span>
                  </label>
                </div>
              </div>
              <div className="mb-4">
                <input
                  type="text"
                  placeholder={t('order.enterCardNumber')}
                  className="w-[440px] p-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-gray-500"
                />
              </div>

              <div className="flex justify-between space-x-4">
                <div className="w-1/2">
                  <input
                    type="text"
                    placeholder={t('order.expiryDate')}
                    className="w-full p-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-gray-500"
                  />
                </div>
                <div className="w-1/2">
                  <input
                    type="text"
                    placeholder={t('order.cvv')}
                    className="w-full p-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-gray-500"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col-span-2">
          <div className="bg-white p-6 shadow-lg rounded-lg h-[330px] ">
            <div className="flex flex-col">
              <div className="my-2 text-2xl">{t('order.myPurchases')}</div>
              <div className="text-center">
                <div className="border-t border-gray-300"></div>
                <div className="flex justify-between my-2 text-gray-500">
                  <div>10 sacs 50 kilo Haricots noir</div>
                  <div>25000F</div>
                </div>
                <div className="border-t border-gray-300"></div>
              </div>

              <div className="flex justify-between">
                <div className="font-bold">{t('order.total')}</div>
                <div className="font-bold">25000F</div>
              </div>

              <div className="flex my-4">
                <div>{t('order.totalPrice')}:</div>
                <div className="font-bold text-1xl ml-2">25000F</div>
              </div>

              <div className="flex justify-center">
                <Button
                  className="bg-green-500 text-white p-2 rounded hover:bg-green-600 w-[200px] mt-6"
                  style={{
                    borderRadius: "50px",
                    height: "2em",
                  }}
                  onClick={handleOpenModal}
                >
                  {t('order.passOrderButton')}
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <ModalComponent isVisible={isModalVisible} onClose={handleCloseModal} />
    </div>
  );
};

export default PasserCommande;